module.exports = __webpack_public_path__ + "img/map.fe9c2a5f.png";